import React from 'react';

import { logInfoMessage } from '../../utils/sentry';

import { type Analytics, type AnalyticsContextType } from './types';

const defaultAnalyticsMethod = () => {
	// tslint:disable-next-line no-console
	// eslint-disable-next-line no-console
	console.warn('No analytics client has been provided.');

	logInfoMessage('Analytics Context accessed before AnalyticsClient was loaded');
};

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
export const defaultAnalyticsClient: Analytics = {
	getAnalyticsWebClient: (): undefined => {
		defaultAnalyticsMethod();
		return;
	},
	pushTrackEvent: defaultAnalyticsMethod,
	pushScreenEvent: defaultAnalyticsMethod,
	pushUIEvent: defaultAnalyticsMethod,
	pushOperationalEvent: defaultAnalyticsMethod,
	startUIViewedEvent: defaultAnalyticsMethod,
	expTracker: () => {
		throw new Error('No analytics client has been provided');
	},
	setTeamId: () => {
		throw new Error('No analytics client has been provided');
	},
	setConsumer: () => {},
};

const AnalyticsContextState: AnalyticsContextType = {
	analytics: defaultAnalyticsClient,
};

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
export const AnalyticsContext = React.createContext(AnalyticsContextState);
